export function getStaticFilterSetInitialState() {
    return {};
}
